/* PNE VAULT V5.0 — lightweight interaction layer */
(() => {
  const qs=(s,r=document)=>r.querySelector(s), qsa=(s,r=document)=>[...r.querySelectorAll(s)];

  const initHeader=()=>{
    const h=qs('.pne-header'); if(!h) return;
    const sync=()=>h.classList.toggle('is-compact',window.scrollY>34);
    sync(); window.addEventListener('scroll',sync,{passive:true});
  };

  const initReveal=()=>{
    const els=qsa('[data-pne-reveal]'); if(!els.length) return;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(el=>el.classList.add('is-inview'));return;}
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-inview');io.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(el=>io.observe(el));
  };

  const initHeroLight=()=>{
    if(!matchMedia('(pointer:fine)').matches) return;
    const hero=qs('.pne-campaign-hero'); if(!hero) return;
    hero.addEventListener('pointermove',e=>{
      const r=hero.getBoundingClientRect();
      hero.style.setProperty('--pne-v5-mx',`${((e.clientX-r.left)/r.width*100).toFixed(1)}%`);
      hero.style.setProperty('--pne-v5-my',`${((e.clientY-r.top)/r.height*100).toFixed(1)}%`);
    },{passive:true});
  };

  const initMarqueeTouch=()=>{
    qsa('.pne-arrivals-marquee__viewport').forEach(v=>{
      const t=qs('.pne-arrivals-marquee__track',v); if(!t) return;
      const pause=()=>t.style.animationPlayState='paused';
      const play=()=>t.style.animationPlayState='running';
      v.addEventListener('pointerdown',pause,{passive:true});
      v.addEventListener('pointerup',play,{passive:true});
      v.addEventListener('pointercancel',play,{passive:true});
    });
  };

  const initShelfFocus=()=>{
    qsa('[data-pne-shelf]').forEach(root=>{
      const rail=qs('.pne-shelf__rail',root); if(!rail) return;
      const boxes=qsa('.pne-shelf-box',rail); if(!boxes.length) return;
      let raf=0;
      const sync=()=>{
        raf=0;
        if(innerWidth>749){boxes.forEach(b=>b.classList.remove('is-mobile-focus'));return;}
        const rr=rail.getBoundingClientRect(), center=rr.left+rr.width/2;
        let best=null,dist=Infinity;
        boxes.forEach(b=>{const r=b.getBoundingClientRect(),d=Math.abs((r.left+r.width/2)-center);if(d<dist){dist=d;best=b}});
        boxes.forEach(b=>b.classList.toggle('is-mobile-focus',b===best));
      };
      const schedule=()=>{if(!raf)raf=requestAnimationFrame(sync)};
      rail.addEventListener('scroll',schedule,{passive:true}); window.addEventListener('resize',schedule,{passive:true}); sync();
    });
  };

  const boot=()=>{initHeader();initReveal();initHeroLight();initMarqueeTouch();initShelfFocus();};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',()=>{initReveal();initShelfFocus();});
})();

/* PNE V5.0.2 — Featured Showroom rotation */
(() => {
  const initFeaturedShowroom = (root = document) => {
    root.querySelectorAll('[data-pne-featured-showroom]').forEach(showroom => {
      if (showroom.dataset.featuredReady === '1') return;
      showroom.dataset.featuredReady = '1';

      const slides = [...showroom.querySelectorAll('[data-featured-slide]')];
      const nav = [...showroom.querySelectorAll('[data-featured-nav]')];
      const currentEl = showroom.querySelector('[data-featured-current]');
      const progress = showroom.querySelector('[data-featured-progress]');
      if (slides.length < 2) return;

      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const isMobile = () => matchMedia('(max-width: 749px)').matches;
      const duration = Math.max(5, Number(showroom.dataset.autoplay || 7)) * 1000;
      showroom.style.setProperty('--pne-featured-duration', `${duration / 1000}s`);

      let index = 0;
      let timer = 0;
      let visible = true;
      let hoverPaused = false;
      let mobileTouched = false;
      let touchX = 0, touchY = 0;

      const pad = n => String(n + 1).padStart(2, '0');
      const restartProgress = () => {
        if (!progress) return;
        progress.style.animation = 'none';
        void progress.offsetWidth;
        progress.style.animation = '';
      };
      const update = (next, user = false) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        nav.forEach((btn, i) => {
          const active = i === index;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (currentEl) currentEl.textContent = pad(index);
        restartProgress();
        if (user && isMobile()) mobileTouched = true;
        schedule();
      };
      const canPlay = () => !reduceMotion && visible && !hoverPaused && !(isMobile() && mobileTouched);
      const schedule = () => {
        clearTimeout(timer);
        showroom.classList.toggle('is-paused', !canPlay());
        showroom.classList.toggle('is-playing', canPlay());
        if (canPlay()) timer = setTimeout(() => update(index + 1, false), duration);
      };

      nav.forEach((btn, i) => btn.addEventListener('click', () => update(i, true)));
      showroom.addEventListener('mouseenter', () => { if (!isMobile()) { hoverPaused = true; schedule(); } });
      showroom.addEventListener('mouseleave', () => { if (!isMobile()) { hoverPaused = false; schedule(); } });
      showroom.addEventListener('touchstart', e => {
        const t = e.changedTouches[0]; touchX = t.clientX; touchY = t.clientY;
      }, { passive: true });
      showroom.addEventListener('touchend', e => {
        const t = e.changedTouches[0];
        const dx = t.clientX - touchX, dy = t.clientY - touchY;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.25) update(index + (dx < 0 ? 1 : -1), true);
        else if (isMobile()) { mobileTouched = true; schedule(); }
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
          entries.forEach(entry => { visible = entry.isIntersecting && entry.intersectionRatio > .18; schedule(); });
        }, { threshold: [0, .18, .5] });
        io.observe(showroom);
      }
      window.addEventListener('resize', schedule, { passive: true });
      update(0, false);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFeaturedShowroom(document), { once: true });
  else initFeaturedShowroom(document);
  document.addEventListener('shopify:section:load', e => initFeaturedShowroom(e.target));
})();
